let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iGFLn")).then(() => parcelRequire('3OMt0'));